import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { IUserRelation, IUserRelationProps, IUserRelationStates } from "./interfaces";
import { IZobdehUserProps, ZobdehUser } from "./zobdehUser";

export class UserRelation extends EntityManager<IUserRelation, IUserRelationProps, IUserRelationStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "",
            title: "",
            Properties: [
                {
                    title: "کاربر",
                    dataIndex: "UserId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 300,
                    rules: [{ required: true, message: 'کاربر اجباری است' }],
                    lookup: {
                        lookupComponent: ZobdehUser,
                        lookupProperty: "User",
                        lookupDisplayFields: ["UserName", "FullName"]
                    }
                }
            ]
        };
    }

    onInitializing() {
        this.metadata.name = this.props.metadataName;
        this.metadata.title = this.props.title;
        this.insertButtonTitle = () => "افزودن";
        this.preparelookupProps = (propName, lookupProps) => {
            if (propName === "UserId")
                (lookupProps as IZobdehUserProps).userType = this.props.userType;
            return lookupProps;
        }
        this.extraHeaderNodes = () => {
            return (
                <Descriptions className="header-page">
                    <Descriptions.Item label="مرجع">{this.props.params && this.props.params().description}</Descriptions.Item>
                </Descriptions>
            );
        }
        this.onEntityAdded = (entity: IUserRelation) => {
            let sourceId = this.props.params && this.props.params().sourceId;
            if (sourceId) {
                entity.SourceId = sourceId;
                entity.ModifiedProperties.push("SourceId");
            }
            return true;
        };
        this.originalFilter = () => {
            let sourceId = this.props.params && this.props.params()?.sourceId;
            if (sourceId) {
                return ComparisonFilter.Equal<IUserRelation>(m => m.SourceId, sourceId);
            }
        };
    }
}